module.exports = __webpack_public_path__ + "media/images/post/icon_sns_pinterest-9cb94c977087c2a22bf7bfd5a8b035df.svg";